import Flex from 'legacyfrontend/components/Flex';
import LoadSpinner from 'legacyfrontend/components/spinner';
import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { useNavigation } from 'legacyfrontend/hooks/useNavigation';
import { HiShare } from 'react-icons/hi';
import { connect } from 'react-redux';
import { WhatsappIcon, WhatsappShareButton } from 'react-share';
import { getBanner } from '../../api/services/marcaBlancaClientServices';
import Tag from '../../components/tag';
import ContactFormModal from '../../components/ContactFormModal';
import ShareButton from '../../components/ui/ShareButton';
import ImageGallery from './components/ImageGallery';
const propertiesToTab = ['itinerario', 'incluye', 'hoteles', 'tarifas', 'salida', 'detalle'];

const BannerDetail = (props) => {
  const { t } = useTranslation('layout');
  const { t: t2 } = useTranslation('translations');

  const location = useLocation();
  const { goBack } = useNavigation();
  const [bannerData, setBannerData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [consultaBanner, setConsultaBanner] = useState();
  const [currentTab, setCurrentTab] = useState();
  const [shareUrl, setShareUrl] = useState('');
  const encode = encodeURIComponent;

  useEffect(() => {
    const fetchBanner = async () => {
      try {
        setIsLoading(true);
        const data = await getBanner(props.match.params.id, props.token);
        setBannerData(data);
        setError(null);
        const baseUrl = typeof window !== 'undefined' ? window.location.origin : '';
        setShareUrl(`${baseUrl}/bannershare/${encode(data.id)}`);
      } catch (err) {
        console.error('Error fetching banner:', err);
        setError(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchBanner();
  }, [props.match.params.id, encode, props.token]);

  const translationMap = {
    itinerario: t('layout:packages.details.itinerary'),
    incluye: t('layout:packages.details.included'),
    hoteles: t('layout:packages.details.hotels'),
    tarifas: t('layout:packages.details.rates'),
    salida: t('layout:packages.details.departure'),
    detalle: t('layout:packages.details.detail'),
  };

  const translationMapInverse = {
    itinerary: 'itinerario',
    includes: 'incluye',
    hotels: 'hoteles',
    rates: 'tarifas',
    departure: 'salida',
    detail: 'detalle',
  };

  const orderSpanishArray = (englishArray, spanishArray) => {
    const orderedSpanishArray = englishArray
      .map((englishKey) => translationMapInverse[englishKey.toLowerCase()])
      .filter((key) => spanishArray.includes(key));

    return orderedSpanishArray;
  };

  const tabs = useMemo(() => {
    if (bannerData) {
      const arrayOrder = orderSpanishArray(bannerData.ordenSecciones, propertiesToTab);
      const tabsContent = arrayOrder
        .map((key) => {
          const content = bannerData[key];
          const translatedKey = translationMap[key.toLowerCase()] || key;
          return content ? [translatedKey, content] : undefined;
        })
        .filter(Boolean);

      return tabsContent?.length ? tabsContent : undefined;
    }
    return undefined;
  }, [bannerData]);

  useEffect(() => {
    if (!isLoading && bannerData && !!tabs?.length) {
      setCurrentTab(tabs[0][0]);
    }
  }, [bannerData, isLoading, tabs]);

  const shareBanner = async () => {
    navigator.clipboard.writeText(shareUrl);
    alert(t('common.link_copied'));
  };

  return (
    <>
      {bannerData && !isLoading ? (
        <Flex className='banner-detail-container p-4 gap-8' vertical>
          <Flex className='banner__header'>
            <h3 className='text-lg flex items-center'>
              <i
                className='fa fa-chevron-left bg-white w-8 h-8 rounded-full flex items-center justify-center cursor-pointer transition-all duration-300 mr-2 hover:bg-black/10'
                onClick={goBack}
              />
              {bannerData.titulo}
            </h3>
          </Flex>
          <Flex className='boxes-wrapper'>
            <Flex className='boxes-wrapper banner-information' vertical>
              <ImageGallery
                items={
                  bannerData.bannerImagenes?.length
                    ? bannerData.imageDescriptionBanner
                      ? [bannerData.imagen, ...bannerData.bannerImagenes]
                      : [...bannerData.bannerImagenes]
                    : bannerData.imageDescriptionBanner
                      ? [bannerData.imagen]
                      : []
                }
              />
            </Flex>
            <Flex className='boxes-wrapper banner-details' vertical>
              <Flex className='banner-details-card card-box' vertical>
                <Flex className='banner-details__payment-card__header' vertical>
                  <Flex className='banner-details__payment-card__header__data' vertical>
                    <p className='banner-details__payment-card__header__title'>
                      {bannerData.titulo}
                    </p>
                    <p className='banner-details__payment-card__header__description'>
                      {bannerData.descripcion}
                    </p>
                  </Flex>
                  <Flex className='banner-details__tags'>
                    {[bannerData.extra, bannerData.precio, bannerData.descuento]
                      .filter(Boolean)
                      .map((item, index) => (
                        <Tag key={item + index} text={item} />
                      ))}
                  </Flex>
                </Flex>
              </Flex>
              <div className='banner-details-buttons'>
                <button
                  className='banner-details-button banner-details__ask-button'
                  onClick={() => {
                    setConsultaBanner({
                      ...bannerData,
                      link: location.pathname,
                    });
                  }}
                >
                  {t2('translations:ask_about')}
                </button>
                <ShareButton 
                  url={shareUrl}
                  title="Compartir banner"
                />
              </div>
            </Flex>
          </Flex>
          {!!currentTab && !!tabs?.length && (
            <Flex vertical className='card-box banner-information__description-card'>
              <ul className='flex flex-wrap gap-2 items-center with-bottom-divider'>
                {tabs.map(([tabName]) => (
                  <li
                    key={tabName}
                    className={`w-36 inline-flex rounded-sm p-4 cursor-pointer uppercase leading-4 items-center justify-center transition-all duration-300${tabName === currentTab ? ' bg-[var(--mbr-background)] text-[var(--mbr-text)]' : ''}`}
                    onClick={() => setCurrentTab(tabName)}
                  >
                    {tabName}
                  </li>
                ))}
              </ul>
              <Flex
                dangerouslySetInnerHTML={{
                  __html: Object.fromEntries(tabs)[currentTab],
                }}
                vertical
                className='banner-information__description-card__inserted-html ql-editor'
                id='tabContent'
              />
            </Flex>
          )}
          <ContactFormModal
            consultaPackage={consultaBanner}
            onClose={() => setConsultaBanner(undefined)}
            variant='banner'
            title='Enviá tu consulta'
            subtitle={consultaBanner?.titulo}
          />
        </Flex>
      ) : (
        <Flex
          style={{
            flex: 1,
            height: '30rem',
            justifyContent: 'center',
            padding: '8rem 0',
          }}
        >
          <LoadSpinner />
        </Flex>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  token: state.applicationState.token,
});

export default connect(mapStateToProps)(BannerDetail);
